import { render, staticRenderFns } from "./TransactionOptionsItem.vue?vue&type=template&id=527a827c&"
import script from "./TransactionOptionsItem.vue?vue&type=script&lang=js&"
export * from "./TransactionOptionsItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionOptionsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports